
import { Component, Prop, Vue } from "vue-property-decorator";
import {
  autoLinkNoteHtml,
  noteHtmlToPlainText,
  noteHtmlToSingleLine,
  toNoteHtml,
} from "@/utils/richText";

/**
 * Zobrazí formátovanou poznámku uloženou komponentou RichTextInput.
 *
 * Obsah vždy projde sanitizací, protože poznámku může napsat i zákazník.
 * V režimu `plain` se formátování zahodí - pro místa, kde není na formátovaný
 * text prostor (tooltip na dispečerské tabuli). V režimu `singleLine`
 * formátování zůstane, jen se poznámka zploští na jeden řádek - pro pruhy,
 * kde je na poznámku jen jeden řádek (poznámka slotu na tabuli).
 */
@Component({
  name: "RichTextDisplay",
})
export default class RichTextDisplay extends Vue {
  @Prop()
  value: string | null | undefined;

  @Prop({ type: Boolean, default: false })
  plain: boolean;

  @Prop({ type: Boolean, default: false })
  singleLine: boolean;

  /** Text zobrazený u prázdné poznámky. Bez něj se nevykreslí nic. */
  @Prop({ default: null })
  emptyText: string | null;

  get html(): string {
    return this.singleLine
      ? noteHtmlToSingleLine(this.value)
      : autoLinkNoteHtml(toNoteHtml(this.value));
  }

  get plainText(): string {
    return noteHtmlToPlainText(this.value);
  }

  /**
   * Poznámky se zobrazují i v kartách, které samy reagují na kliknutí -
   * kliknutí na odkaz proto nesmí probublat výš.
   */
  onContentClicked(event: MouseEvent) {
    const target = event.target as HTMLElement | null;
    if (target?.closest("a") != null) {
      event.stopPropagation();
    }
  }
}
